import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Paper, SvgIcon, TextField, Typography } from '../../../elements';
import { Container, OptionsTitle, OptionsWrapper, Title } from './Step.style';
import { ToggleButton } from '@mui/material';
import { t } from '../../../../../js/common/translations';

const initialTimes = [
  {
    hour: '9:00',
    disabled: false
  },
  {
    hour: '9:30',
    disabled: false
  },
  {
    hour: '10:00',
    disabled: false
  },
  {
    hour: '10:30',
    disabled: false
  },
  {
    hour: '11:00',
    disabled: false
  },
  {
    hour: '11:30',
    disabled: false
  },
  {
    hour: '12:00',
    disabled: false
  },
  {
    hour: '12:30',
    disabled: false
  },
  {
    hour: '13:00',
    disabled: false
  },
  {
    hour: '13:30',
    disabled: false
  },
  {
    hour: '14:00',
    disabled: false
  },
  {
    hour: '14:30',
    disabled: false
  },
  {
    hour: '15:00',
    disabled: false
  },
  {
    hour: '15:30',
    disabled: false
  },
  {
    hour: '16:00',
    disabled: false
  },
  {
    hour: '16:30',
    disabled: false
  },
  {
    hour: '17:00',
    disabled: false
  },
  {
    hour: '17:30',
    disabled: false
  }
];

const StepTwo = ({
  handleSetStep,
  visitForm,
  setVisitForm,
  notAvailable,
  handleChange,
  getErrorMessage,
  memberSignedIn,
  setFormErrorsText
}) => {
  const handleTimeChange = (value) => {
    setVisitForm(state => ({
      ...state,
      time: value
    }));
  };

  const [times, setTimes] = useState(initialTimes);

  useEffect(() => {
    const weekday = new Date(visitForm.date).toLocaleString('en-US', {
      weekday: 'long',
      timeZone: 'UTC'
    });
    const isWeekend = weekday === 'Saturday' || weekday === 'Sunday';

    const updatedTimes = initialTimes.map(timeItem => ({
      ...timeItem,
      disabled: visitForm.date === '' || isWeekend || notAvailable.some(item => item.scheduled_at.includes(timeItem.hour))
    }));

    if (isWeekend) {
      setFormErrorsText([{ field: 'date', error: t('visit_form.step_two.weekend_date_error') }]);
    }

    setTimes(updatedTimes);
  }, [notAvailable, visitForm.date]);

  return (
    <Container>
      <Paper sx={{ padding: '24px', maxWidth: { xs: '100%', md: '575px' } }}>
        <Box>
          <Title>{t('visit_form.step_two.title')}</Title>
          <Box>
            <OptionsTitle>{t('visit_form.step_two.choose_day')}</OptionsTitle>
            <OptionsWrapper sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
              <TextField
                error={!!getErrorMessage('date')}
                helperText={getErrorMessage('date')}
                onChange={handleChange('date')}
                value={visitForm.date}
                onKeyDown={(e) => e.preventDefault()}
                type='date'
                InputProps={{
                  inputProps: {
                    min: `${new Date().getFullYear()}-${new Date().getMonth() < 9 && '0'}${new Date().getMonth() + 1}-${new Date().getDate()}`
                  }
                }}
                sx={{ width: '100%', '& legend': { display: 'none' } }}
              />
            </OptionsWrapper>
          </Box>
          <Box>
            <OptionsTitle>{t('visit_form.step_two.choose_period')}</OptionsTitle>
            <OptionsWrapper
              time
              sx={{
                gridTemplateColumns: { xs: 'auto auto auto', md: 'auto auto auto auto auto' }
              }}
            >
              {times.map((item, i) => {
                return (
                  <ToggleButton
                    value={item.hour}
                    key={i}
                    disabled={item.disabled}
                    onClick={() => handleTimeChange(item.hour)}
                    selected={visitForm?.time === item.hour}
                    sx={{
                      px: '1.5rem',
                      py: '0.5rem',
                      mr: '0.5rem',
                      mb: '0.5rem',
                      color: '#374659',
                      borderRadius: '50px',
                      textTransform: 'capitalize',
                      background: '#F7F8FC',
                      border: 'none',
                      '&.Mui-selected': {
                        background: 'rgba(52, 52, 52, 0.1)'
                      }
                    }}>
                    <Typography sx={{ fontWeight: '600' }}>{item.hour}</Typography>
                  </ToggleButton>
                );
              })}
            </OptionsWrapper>
            <Box sx={{ mb: '32px' }}>
              {!!getErrorMessage('time') && <Typography sx={{ fontSize: '0.75rem', color: '#FF5252' }}>
                <SvgIcon name='error_input_icon' mr={0.375} />
                {getErrorMessage('time')}
              </Typography>
              }
            </Box>
          </Box>
          <Typography mb='4px'>{t('visit_form.step_two.extra_comments')}</Typography>
          <TextField
            multiline
            rows={5}
            value={visitForm.extra_comments}
            onChange={handleChange('extra_comments')}
            sx={{
              width: '100%',
              '& legend': {
                display: 'none'
              }
            }}
            placeholder={t('visit_form.step_two.add_extra_comment')}
          />
          <Divider sx={{ mt: '32px' }} />
          <Box display="flex" sx={{ mt: '24px' }}>
            <Button
              size="large"
              onClick={() => memberSignedIn
                ? window.history.back()
                : handleSetStep({ step: 'one', back: true })}
              variant='outlined'
              sx={{
                width: '100%', mr: '0.75rem'
              }}
            >
              {t('visit_form.back_button')}
            </Button>
            <Button
              size="large"
              onClick={() => handleSetStep({ step: 'three' })}
              sx={{ width: '100%', ml: '0.75rem' }}
            >
              {t('visit_form.step_two.confirm_visit')}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default StepTwo;
